import React, { useState, useCallback } from "react";
import { Snackbar, Alert } from "@mui/material";

export const useSnackbar = () => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = useCallback((message, severity = "success") => {
    setSnackbarState({ open: true, message, severity });
  }, []);

  const handleClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  const SnackbarComponent = () => (
    <Snackbar
      open={snackbarState.open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbarState.severity}
        // sx={{ width: "100%" }}
        sx={{
          width: "100%",
          fontSize: "1rem",
        }}
      >
        {snackbarState.message}
      </Alert>
    </Snackbar>
  );

  return [SnackbarComponent, showSnackbar];
};
